import { render } from "./SelectBrandsSelected.vue?vue&type=template&id=26966b84&scoped=true&ts=true"
import script from "./SelectBrandsSelected.vue?vue&type=script&lang=ts"
export * from "./SelectBrandsSelected.vue?vue&type=script&lang=ts"

import "./SelectBrandsSelected.vue?vue&type=style&index=0&id=26966b84&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26966b84"]])

export default __exports__